import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Water Mass Calculator - Calculate Water Mass Based on Volume and Water Density';
const DESCRIPTION = 'The Water Mass Calculator calculates water mass based on volume and water density.';
const KEYWORDS = 'Water mass, Calculate water mass, Water mass calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/water-mass';
function Calculator() {
    const [waterVolume, setWaterVolume] = useState('');
    const [waterMass, setWaterMass] = useState('');
    const [error, setError] = useState('');
    const waterDensity = 1000;
    const handleCalculate = () => {
        if (!waterVolume) {
            setError('Please enter the water volume in cubic meters correctly');
            setWaterMass('');
            return;
        }
        const volumeValue = parseFloat(waterVolume);
        if (isNaN(volumeValue) || volumeValue < 0) {
            setError('Please enter a valid non-negative value for water volume in cubic meters');
            setWaterMass('');
            return;
        }
        const mass = volumeValue * waterDensity;
        setWaterMass(mass.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Water Mass</h2>
                                        <p>
                                            Water mass is calculated based on volume and water density. Enter the water volume in cubic meters,
                                            then multiply the volume by the water density to get the water mass in kilograms.
                                        </p>
                                        <p>
                                            Water Mass = Volume (cubic meters) x Water Density (kilograms per cubic meter)
                                        </p>
                                        <p>
                                            This calculator can be used to calculate water mass based on the entered values.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Water Volume (cubic meters)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Water volume in cubic meters"
                                                        value={waterVolume}
                                                        onChange={(e) => setWaterVolume(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Water Mass
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {waterMass !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Water Mass: {waterMass} kilograms
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>
                                                                    This value represents the mass represented by the water based on the volume you entered and the water density.
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
